import React, { useState } from 'react';

import { useField } from 'formik';

import { Button, Text } from '@shared/components/bootstrap';
import { FieldFormGroupProps } from '@shared/components/fields/field_form_group';
import { FormikFieldFormGroup } from '@shared/components/fields/formik/formik_field_form_group';

import { FileFormControl } from '../file_form_control';

type Attachment = {
  id: string;
  filename: string;
  signedID: string;
  url: string;
};

type Upload = {
  file: File;
  signedID: string;
};

type InputFormGroupProps = FieldFormGroupProps & {
  name: string;
  accept: string;
  initial?: Attachment;
};

export const FormikFileFormGroup: React.FC<InputFormGroupProps> = ({ accept, name, initial, ...props }) => {
  const [_input, _meta, helpers] = useField<string | undefined>(name);
  const [resource, setResource] = useState<Upload | Attachment | null>(initial ?? null);

  const onUpload = (file: File, signedID: string) => {
    setResource({ file, signedID });
    helpers.setValue(signedID);
  };

  const onClear = () => {
    setResource(null);
    helpers.setValue(undefined);
  };

  return (
    <FormikFieldFormGroup name={name} {...props}>
      <div>
        {resource ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
            <Text wrapping="truncate">
              {'filename' in resource ? (
                <a href={resource.url} target="_blank" rel="noopener noreferrer">
                  {resource.filename}
                </a>
              ) : (
                resource.file.name
              )}
            </Text>
            <Button kind="danger" size="sm" onClick={() => onClear()}>
              Remove
            </Button>
          </div>
        ) : (
          <FileFormControl id={name} accept={accept} onUpload={onUpload} label="Choose File" />
        )}
      </div>
    </FormikFieldFormGroup>
  );
};
